export default __webpack_public_path__ + "static/media/WordSelectionBackground.611959c3.webp";